import { Mode } from './enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.PLAIN]: css.plain,
  [Mode.BLACK]: css.black,
  [Mode.TRANSPARENT]: css.transparent,
};
